<div class="dropdown">
    <!-- Dropdown toggle -->
    <div
        class="c-dropdown-toggle"
        data-bs-toggle="dropdown"
        data-bs-boundary="viewport"
        data-bs-offset="0,12"
        [attr.data-testid]="testIdPrefix ? testIdPrefix + '-accounting-period-button' : null"
    >
        <img src="assets/icons/calendar-with-dollar-icon-white.svg" />
    </div>

    <!-- Dropdown menu -->
    <div class="dropdown-menu dropdown-menu-end">
        <!-- <img class="pointer" src="assets/icons/triangle.svg" /> -->
        <div class="menu-container">
            <div class="heading">
                <img src="assets/icons/calendar-with-dollar-icon-blue.svg" />
                <span class="heading-label"><ng-container i18n="@@accountingPeriod">Accounting Period</ng-container>:</span>
                @if (activePeriod.dateStart) {
                    <span class="heading-value">{{ activePeriod.dateStart | date : 'MMMM' }} {{ activePeriod.fiscalYear }}</span>
                }
            </div>
            <div class="content">
                <div class="content-item">
                    <div class="label"><ng-container i18n="@@openPeriods">Open Periods</ng-container>:</div>
                    @if (openPeriod.display) {
                        <div class="value">{{ openPeriod.display }}</div>
                    }
                </div>
                <div class="content-item">
                    <div class="label"><ng-container i18n="@@gracePeriod">Grace Period</ng-container>:</div>
                    @if (openPeriod.gracePeriodDate) {
                        <div class="value">{{ openPeriod.gracePeriodDate | date : 'MMMM d, y' }}</div>
                    }
                </div>
            </div>
        </div>
        
    </div>
</div>